import { FC, PropsWithChildren, useContext } from "react";
import PermissionsContext from "../../../contexts/auth/PermissionsContext";
import usePermissions from "../../../hooks/auth/usePermissions";
import { AuthenticatedUserContext } from "@ngt/forms";

const PermissionsProvider:FC<PropsWithChildren> = ({
    children
}) => {
    const {data: user} = useContext(AuthenticatedUserContext);
    const response = usePermissions(user);
    return (
        <PermissionsContext.Provider value={response}>
            {children}
        </PermissionsContext.Provider>
    );
} 

export default PermissionsProvider;